import type { CardTextProps } from '@Components/BigBrowse/GridCardMesh/Components/Texts/CardText';
import { Assets } from '@Utils/AssetsStore';

export const FIGMA_MARGIN_INTERNAL_3_COLUMN = 54;
export const MULTI_SECTION_DESCRIPTION_TITLE_TEXT_PROPS: Omit<
  CardTextProps,
  'text'
> = {
  fontAsset: Assets.Font_Gilroy_Bold,
  fontSize: 48,
  lineHeight: 52 / 48,
  letterSpacing: 0.03,
};
export const MULTI_SECTION_DESCRIPTION_TITLE_TEXT_PROPS_MOBILE: Omit<
  CardTextProps,
  'text'
> = {
  fontAsset: Assets.Font_Gilroy_Bold,
  fontSize: 26,
  lineHeight: 28 / 26,
  letterSpacing: 0.03,
};
export const MULTI_SECTION_DESCRIPTION_BODY_TEXT_PROPS_MOBILE: Omit<
  CardTextProps,
  'text'
> = {
  fontAsset: Assets.Font_Gilroy_Medium,
  fontSize: 14,
  lineHeight: 18 / 14,
  letterSpacing: 0.03,
};
export const MULTI_SECTION_DESCRIPTION_BODY_TEXT_PROPS: Omit<
  CardTextProps,
  'text'
> = {
  fontAsset: Assets.Font_Gilroy_Medium,
  fontSize: 18,
  lineHeight: 22 / 18,
  letterSpacing: 0.03,
};
export const MULTI_SECTION_DESCRIPTION_INTERNAL_MARGIN = 50;
export const MULTI_SECTION_DESCRIPTION_INTERNAL_MARGIN_MOBILE = 23;
export const MULTI_SECTION_HERO_BOTTOM_GAP_MOBILE = 34;

export const MULTI_SECTION_SHELF_TOP_GAP = 100;
export const MULTI_SECTION_SHELF_TOP_GAP_MOBILE = 35;
